<template>
  <div class="mod-config">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item style="float: left;" label="设备名称：">
        <el-input v-model="dataForm.deviceName" placeholder="设备名称" clearable></el-input>
      </el-form-item>
      <el-form-item style="float: left;" label="告警类型：">
        <el-select v-model="dataForm.alarmType" placeholder="请选择" style="width: 100%">
          <el-option label="所有" :value="0"></el-option>
          <el-option label="缺失" :value="1"></el-option>
          <el-option label="故障" :value="2"></el-option>
          <el-option label="超标" :value="3"></el-option>
          <el-option label="恢复" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item style="float: left;" label="告警时间：">
        <el-date-picker v-model="dataForm.dateStr" :picker-options="dataForm.pickerOptions" type="datetimerange"
          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :format="dataForm.formatTime"
          :value-format="dataForm.formatTime">
        </el-date-picker>
      </el-form-item>
      <el-button type="primary" icon="el-icon-search" style="float: left;" @click="search"></el-button>
      <el-form-item style="float: right;">
        <el-button size="mini" icon="el-icon-back" @click="returnd()" style="font-size: 18px;"></el-button>
      </el-form-item>
    </el-form>
    <el-table :data="dataList" v-loading="loading" @selection-change="selectionChangeHandle" style="width: 100%;"
      height="calc(100% - 102px)" border stripe :header-cell-style="{ background: '#FAFAFA' }" placement="top">
      <el-table-column prop="userId" header-align="center" align="center" label="告警编号/推送编号">
      </el-table-column>
      <el-table-column prop="alarmType" header-align="center" align="center" label="推送类型" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="createTime" header-align="center" align="center" label="推送时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="pushType" header-align="center" align="left" label="推送方式" show-overflow-tooltip>
        <template slot-scope="scope">
          <!-- <label v-if="scope.row.pushType == '1'">
            语音
          </label>
          <label v-if="scope.row.pushType == '0'">
            短信
          </label>
          <label v-if="scope.row.pushType == '2'">
            邮件
          </label>  -->
          <label v-if="scope.row.pushType == 0">短信</label>
          <label v-else-if="scope.row.pushType == 1">语音</label>
          <label v-else-if="scope.row.pushType == 2">邮件</label>
        </template>
      </el-table-column>
      <el-table-column prop="resultData" header-align="center" align="center" label="推送结果">
      </el-table-column>
    </el-table>
    <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
      layout="prev, pager, next, jumper, total,sizes">
    </el-pagination>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      dataForm: {
        deviceName: '',
        alarmType: '',
        dateStr: new Date(),
        dateFromStr: '',
        dateToStr: '',
        formatTime: "yyyy-MM-dd",
      },
      pageIndex: 1,
      pageSize: 20,
      totalPage: 0,
      dataList: [],
      dataListSelections: [],
    }
  },
  created() {
    this.getDataList();
  },
  methods: {
    search() {
      if (this.dataForm.dateStr) {
        this.dataForm.dateFromStr = this.dataForm.dateStr[0]
        this.dataForm.dateToStr = this.$moment(this.dataForm.dateStr[1]).add(1, 'days').format("yyyy-MM-DD")
      }
      this.tableData = []
      this.pageIndex = 1;
      if (this.dataForm.dateFromStr == undefined || this.dataForm.dateFromStr == '') {
        this.getDataList()
      } else {
        this.sousuo();
      }
    },
    // 获取数据列表
    getDataList() {
      this.loading = true
      //时间条件
      if (this.dataForm.dateStr) {
        this.dataForm.dateFromStr = this.dataForm.dateStr[0]
        this.dataForm.dateToStr = this.dataForm.dateStr[1]
      }
      this.$http({
        url: this.$http.adornUrl("alarmPush/record"),
        method: 'get',
        params: this.$http.adornParams({
          'deviceName': this.dataForm.deviceName,
          'alarmType': this.dataForm.alarmType,
          'pageNum': this.pageIndex,
          'pageSize': this.pageSize,
        })
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.dataList = data.data.rows;
          this.totalPage = data.data.total; 
        } else {
          this.dataList = []
          this.totalPage = 0
          this.$message.error(data.msg);
        }
        this.loading = false
        //重置参数
        this.dataForm.dateFromStr = '';
        this.dataForm.dateToStr = '';
      })
    },
    sousuo() {
      this.loading = true 
      this.$http({
        url: this.$http.adornUrl("alarmPush/record"),
        method: 'get',
        params: this.$http.adornParams({
          'deviceName': this.dataForm.deviceName,
          'alarmType': this.dataForm.alarmType,
          'pageNum': this.pageIndex,
          'pageSize': this.pageSize,
          'dateFromStr': this.dataForm.dateFromStr + " 00:00:00",
          'dateToStr': this.dataForm.dateToStr + " 00:00:00",
        })
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.dataList = data.data.rows;
          this.totalPage = data.data.total;
        } else {
          this.dataList = []
          this.totalPage = 0
          this.$message.error(data.msg);
        }
        this.loading = false
        //重置参数
        this.dataForm.dateFromStr = '';
        this.dataForm.dateToStr = '';
      })
    },
    returnd() {
      this.$router.replace({ path: '/indexhome/management/index' });
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val;
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
  }
}
</script>
<style></style>


// WEBPACK FOOTER //
// src/pages/admincenter/management/record.vue